<template>
  <v-container>
    <v-card class="pa-16">
      <v-row>
        <v-col cols="12" md="6">
          <v-card-title class="text-h5"> Import Leave Quota</v-card-title>
        </v-col>
        <v-col align="right" color="primary" cols="12" md="6"> </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="6">
          <v-card-title class="text-h5">
            <input
              type="file"
              accept=".xlsx"
              @change="Readleavequota"
              ref="file"
              style="display: none"
            />
            <v-btn
              outlined
              class="btnuploadfile"
              @click="$refs.file.click()"
              elevation="7"
            >
              <v-icon left dark>mdi-download </v-icon>Import Leave Quota</v-btn
            >
          </v-card-title>
        </v-col>
        <xlsx-read :file="datafile">
          <xlsx-json @parsed="onParsed">
            <!-- <template #default="{collection}">
              <p
                :style="{
                  visibility: showcheckdatafile ? 'visible' : 'hidden',
                }"
                v-if="collection && lockcollection"
                v-html="getInfo(collection)"
              ></p>
            </template> -->
          </xlsx-json>
        </xlsx-read>
        <v-col align="right" color="primary" cols="12" md="6"> </v-col>
      </v-row>
      <v-card outlined tile>
        <v-row v-if="mDataArray.length > 0">
          <v-col justify="left" align="left">
            <h3>
              <v-icon small center>mdi-play</v-icon> Import File Name =
              {{ filenameimport }}
            </h3>

            <h3>
              <v-icon small center>mdi-play</v-icon> Import All =
              {{ mDataArray.length }} rows
            </h3>
            <h3>
              <v-icon small center>mdi-play</v-icon> Import Success =
              <span v-if="countsuccess > 0" class="green--text">{{
                countsuccess
              }}</span>
              <span v-else> {{ countsuccess }}</span> rows
            </h3>
            <h3>
              <v-icon small center>mdi-play</v-icon> Import Fail =
              <span v-if="countfail > 0" class="red--text">{{
                countfail
              }}</span>
              <span v-else> {{ countfail }}</span> rows
              <br />
                <span style="padding-left: 50px;"> 
                  1. Duplicate data =
                  <span v-if="datafailleavequota > 0" class="red--text">{{ datafailleavequota }}</span>
                  <span v-else> {{ datafailleavequota }} </span> 
                  rows 
                </span>
                <br />
                <span style="padding-left: 50px;">
                  2. Leave Type Error =
                  <span v-if="datafailleavetype > 0" class="red--text">{{ datafailleavetype }}</span>
                  <span v-else> {{ datafailleavetype }} </span>
                  rows
                </span >
                <br />
                <span style="padding-left: 50px;">
                  3. Company Error / Company not macth = 
                  <span v-if="datafailcompany > 0" class="red--text">{{ datafailcompany }}</span>
                  <span v-else> {{ datafailcompany }} </span>
                  rows
                </span>
            </h3>
          </v-col>
        </v-row>

        <v-row>
          <v-col justify="right" align="right">
            <v-btn
              v-if="btnconfirmimport"
              color="#3F7652"
              :disabled="btnconfirmimportclose"
              rounded
              class="mb-2"
              @click="confirmimport()"
            >
              <span>Confirm Import</span>
              <v-icon small center>mdi-checkbox-multiple-marked-circle</v-icon>
            </v-btn>
          </v-col>
        </v-row>

        <v-data-table
          dense
          :search="search"
          :headers="headers"
          :items="mDataArray"
          class="elevation-1   595959"
        >
        </v-data-table>
      </v-card>

      <v-row v-if="employeenamefail || leavetypefail" style="margin-top: 50px;">
        <v-col justify="right" align="right">
          <xlsx-workbook>
            <xlsx-sheet
              :collection="sheet.data"
              v-for="sheet in sheetsdataallfail"
              :key="sheet.name"
              :sheet-name="sheet.name"
            />
            <xlsx-download
              disable-wrapper-click
              :filename="exportleavequotadataallfail"
            >
              <template #default="{download}">
                <v-btn @click="download" rounded class="mb-2 mt-2 buttonred">
                  <span>Export All data Fail!!</span>
                  <v-icon small center>mdi-upload</v-icon>
                </v-btn>
              </template>
            </xlsx-download>
          </xlsx-workbook>
        </v-col>
      </v-row>
      <v-card v-if="employeenamefail" outlined tile style="margin-top: 30px;">
        <v-row style="padding: 30px 0 0 0;">
          <v-col justify="right" align="right">
            <xlsx-workbook>
              <xlsx-sheet
                :collection="sheet.data"
                v-for="sheet in sheetsempfail"
                :key="sheet.name"
                :sheet-name="sheet.name"
              />
              <xlsx-download
                disable-wrapper-click
                :filename="exportleavequotaempfail"
              >
                <template #default="{download}">
                  <v-btn @click="download" rounded class="mb-2 mt-2 buttonred">
                    <span>Export duplicate data!!</span>
                    <v-icon small center>mdi-upload</v-icon>
                  </v-btn>
                </template>
              </xlsx-download>
            </xlsx-workbook>
          </v-col>
        </v-row>
        <v-data-table
          dense
          :search="search"
          :headers="headers"
          :items="mDataempfail"
          class="elevation-1   595959"
        >
        </v-data-table>
      </v-card>

      <v-card v-if="leavetypefail" outlined tile style="margin-top: 30px;">
        <v-row style="padding: 30px 0 0 0;">
          <v-col justify="right" align="right">
            <xlsx-workbook>
              <xlsx-sheet
                :collection="sheet.data"
                v-for="sheet in sheetsleave_typefail"
                :key="sheet.name"
                :sheet-name="sheet.name"
              />
              <xlsx-download
                disable-wrapper-click
                :filename="exportleavequotaleavetypefail"
              >
                <template #default="{download}">
                  <v-btn @click="download" rounded class="mb-2 mt-2 buttonred">
                    <span>Export Leave Type Not Found!!</span>
                    <v-icon small center>mdi-upload</v-icon>
                  </v-btn>
                </template>
              </xlsx-download>
            </xlsx-workbook>
          </v-col>
        </v-row>
        <v-data-table
          dense
          :search="search"
          :headers="headers"
          :items="mDataleavetypefail"
          class="elevation-1   595959"
        >
        </v-data-table>
      </v-card>

      <v-card v-if="datafailcompany > 0" outlined tile style="margin-top: 30px;">
        <v-row style="padding: 30px 0 0 0;">
          <v-col justify="right" align="right">
            <xlsx-workbook>
              <xlsx-sheet
                :collection="sheet.data"
                v-for="sheet in sheetscompanyfail"
                :key="sheet.name"
                :sheet-name="sheet.name"
              />
              <xlsx-download
                disable-wrapper-click
                :filename="exportleavequotacompanyfail"
              >
                <template #default="{download}">
                  <v-btn @click="download" rounded class="mb-2 mt-2 buttonred">
                    <span>Export Company Error!!</span>
                    <v-icon small center>mdi-upload</v-icon>
                  </v-btn>
                </template>
              </xlsx-download>
            </xlsx-workbook>
          </v-col>
        </v-row>
        <v-data-table
          dense
          :search="search"
          :headers="headers"
          :items="mDataCompanyfail"
          class="elevation-1   595959"
        >
        </v-data-table>
      </v-card>
    </v-card>

    <SuccessDialog
      :status="dialogAdd"
      :text_color="text_color"
      :title="title"
      :message="message"
    />

    <SuccessDialogPush
      :status="dialogAdd"
      :text_color="text_color"
      :title="title"
      :message="message"
      :link="link"
    />
  </v-container>
</template>

<script>
import SuccessDialog from "@/components/cards/SuccessDialog";
import SuccessDialogPush from "@/components/cards/SuccessDialogPush";
import api from "@/services/api";
import { server } from "../services/constants";

import {
  XlsxRead,
  XlsxTable,
  XlsxSheets,
  XlsxJson,
  XlsxWorkbook,
  XlsxSheet,
  XlsxDownload,
} from "vue-xlsx";
export default {
  mounted() {
    // this.$showLoader();
    setTimeout(() => {
      this.$hideLoader();
    }, 500);
  },
  components: {
    SuccessDialog,
    SuccessDialogPush,
    XlsxRead,
    XlsxTable,
    XlsxSheets,
    XlsxJson,
    XlsxWorkbook,
    XlsxSheet,
    XlsxDownload,
  },
  data() {
    return {
      lockcollection: false,
      filenameimport: "",
      oldfilenameimport: "",
      dialogAdd: false,
      text_color: "text-h5 green--text text-center",
      title: "green",
      message: "green",
      link: "",
      countsuccess: 0,
      countfail: 0,
      datafailleavequota: 0,
      datafailleavetype: 0,
      datafailcompany: 0,
      sheetsdataallfail: [
        {
          name: "sheetsdataallfail",
          data: [],
        },
      ],
      sheetsempfail: [
        {
          name: "sheetsempfail",
          data: [],
        },
      ],
      sheetsleave_typefail: [
        {
          name: "sheetsleave_typefail",
          data: [],
        },
      ],
      sheetscompanyfail: [
        {
          name: "sheetscompanyfail",
          data: [],
        },
      ],

      btnconfirmimportclose: false,
      exportleavequotaempfail: "leavequota_duplicate_data.xlsx",
      exportleavequotaleavetypefail: "leavequota_leavetype_fail.xlsx",
      exportleavequotacompanyfail: "leavequota_company_fail.xlsx",
      exportleavequotadataallfail: "leavequota_dataall_fail.xlsx",
      employeenamefail: false,
      leavetypefail: false,
      btnconfirmimport: false,
      showcheckdatafile: false,
      datafile: null,
      mDataempfail: [],
      mDataleavetypefail: [],
      mDataCompanyfail: [],
      DataAll: [],
      mDataArray: [],
      mDatafailall: [],
      search: "",
      headers: [
        { text: "company id", value: "company_id" },
        { text: "employee_id", value: "employee_id" },
        { text: "employee_name", value: "employee_name" },
        { text: "leave_period_from", value: "leave_period_from" },
        { text: "leave_period_to", value: "leave_period_to" },
        { text: "leave_type", value: "leave_type" },
        { text: "quota", value: "quota" },
        { text: "use_leave", value: "use_leave" },
        // { text: "status", value: "status" },
      ],
      isShowPassword: false,
      fullPage: true,
    };
  },
  methods: {
    setupAlertDialog(status, title, message, text_color) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
    },
    setupAlertDialogPush(status, title, message, text_color, link) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
      this.link = link;
    },
    async confirmimport() {
      this.btnconfirmimportclose = true;
      console.log(this.mDataArray)

      this.$showLoader();
      const result = await api.importxlsxLeave_quota(localStorage.getItem(server.COMPANYID),this.mDataArray);
      console.log(result.data)
      let dataresult = result.data;
      this.$hideLoader();
      if (
        dataresult.countsuccess === this.mDataArray.length &&
        dataresult.countfail === 0
      ) {
        this.$store.state.global_push_dialog = true;
        this.setupAlertDialogPush(
          true,
          "Information Saved",
          "Information successfully saved",
          "text-h5 green--text text-center",
          "/leave-quota"
        );
        return;
      }
      this.$store.state.global_dialog = true;
      this.setupAlertDialog(
        true,
        "Information Saved",
        "มีข้อมูลผิดพลาด",
        "text-h5 red--text text-center"
      );

      this.countsuccess = dataresult.countsuccess;
      this.countfail = dataresult.countfail;
      


      this.datafailleavequota = dataresult.datafailleavequota.length;
      if (dataresult.datafailleavequota.length > 0) {
        let setdataexportarray = [];
        this.mDataempfail = dataresult.datafailleavequota;
        this.mDataempfail.forEach((x) => {
          let setdataexport = {
            company_id: "",
            employee_id: "",
            employee_name: "",
            leave_period_from: "",
            leave_period_to: "",
            leave_type_id: "",
            leave_type: "",
            quota: "",
            use_leave: "",
          };
          setdataexport.company_id = x.company_id;
          setdataexport.employee_id = x.employee_id;
          setdataexport.employee_name = x.employee_name;
          setdataexport.leave_period_from = x.leave_period_from;
          setdataexport.leave_period_to = x.leave_period_to;
          setdataexport.leave_type_id = x.leave_type_id;
          setdataexport.leave_type = x.leave_type;
          setdataexport.quota = x.quota;
          setdataexport.use_leave = x.use_leave;
          setdataexportarray.push(setdataexport);
        });

        this.sheetsempfail[0].data = setdataexportarray;
        this.employeenamefail = true;
      }

      this.datafailcompany = dataresult.datafailcompany.length;
      if (dataresult.datafailcompany.length > 0) {
        let setdataexportarray = [];
        this.mDataCompanyfail = dataresult.datafailcompany;
        this.mDataCompanyfail.forEach((x) => {
          let setdataexport = {
            company_id: "",
            employee_id: "",
            employee_name: "",
            leave_period_from: "",
            leave_period_to: "",
            leave_type_id: "",
            leave_type: "",
            quota: "",
            use_leave: "",
          };
          setdataexport.company_id = x.company_id;
          setdataexport.employee_id = x.employee_id;
          setdataexport.employee_name = x.employee_name;
          setdataexport.leave_period_from = x.leave_period_from;
          setdataexport.leave_period_to = x.leave_period_to;
          setdataexport.leave_type_id = x.leave_type_id;
          setdataexport.leave_type = x.leave_type;
          setdataexport.quota = x.quota;
          setdataexport.use_leave = x.use_leave;
          setdataexportarray.push(setdataexport);
        });

        this.sheetscompanyfail[0].data = setdataexportarray;

      }

      this.datafailleavetype = dataresult.datafailleavetype.length;
      if (dataresult.datafailleavetype.length > 0) {
        let setdataexportarray = [];
        this.mDataleavetypefail = dataresult.datafailleavetype;
        this.mDataleavetypefail.forEach((x) => {
          let setdataexport = {
            company_id: "",
            employee_id: "",
            employee_name: "",
            leave_period_from: "",
            leave_period_to: "",
            leave_type_id: "",
            leave_type: "",
            quota: "",
            use_leave: "",
          };
          setdataexport.company_id = x.company_id;
          setdataexport.employee_id = x.employee_id;
          setdataexport.employee_name = x.employee_name;
          setdataexport.leave_period_from = x.leave_period_from;
          setdataexport.leave_period_to = x.leave_period_to;
          setdataexport.leave_type_id = x.leave_type_id;
          setdataexport.leave_type = x.leave_type;
          setdataexport.quota = x.quota;
          setdataexport.use_leave = x.use_leave;
          setdataexportarray.push(setdataexport);
        });

        this.sheetsleave_typefail[0].data = setdataexportarray;
        this.leavetypefail = true;
      }

      if (dataresult.datafaileall.length > 0) {
        let setdataexportarray = [];
        this.mDatafailall = dataresult.datafaileall;
        this.mDatafailall.forEach((x) => {
          let setdataexport = {
            company_id: "",
            employee_id: "",
            employee_name: "",
            leave_period_from: "",
            leave_period_to: "",
            leave_type_id: "",
            leave_type: "",
            quota: "",
            use_leave: "",
          };
          setdataexport.company_id = x.company_id;
          setdataexport.employee_id = x.employee_id;
          setdataexport.employee_name = x.employee_name;
          setdataexport.leave_period_from = x.leave_period_from;
          setdataexport.leave_period_to = x.leave_period_to;
          setdataexport.leave_type_id = x.leave_type_id;
          setdataexport.leave_type = x.leave_type;
          setdataexport.quota = x.quota;
          setdataexport.use_leave = x.use_leave;
          setdataexportarray.push(setdataexport);
        });
        this.sheetsdataallfail[0].data = setdataexportarray;
      }
    },
    async getInfo(data) {},
    async Readleavequota(event) {
      this.mDataArray = [];
      this.datafile = null;
      this.datafile = event.target.files ? event.target.files[0] : null;

      this.filenameimport = this.datafile.name;

      this.lockcollection = true;
    },
    importconversedate(input) {
      let date;

      // ตรวจสอบประเภทของ input
      if (typeof input === 'string') {
        date = new Date(input);
      } else if (input instanceof Date) {
        date = input;
      } else if (typeof input === 'number') {
        // ถ้า input เป็นตัวเลข ให้แปลงจากจำนวนวันตั้งแต่วันที่ 1 มกราคม 1970
        date = new Date((input - 25569) * 86400 * 1000); // แปลงตัวเลขเป็นวันที่
      } else {
        throw new Error('Invalid date input. Must be a string, Date object, or number.');
      }

      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); // เดือนเริ่มที่ 0
      const day = String(date.getDate()).padStart(2, '0');

      return `${year}-${month}-${day}`;
    },
    onParsed(data) {

      this.datafailleavequota = 0;
      this.datafailleavetype = 0;
      this.countsuccess = 0;
      this.countfail = 0;
      this.employeenamefail = false;
      this.leavetypefail = false;
      this.mDataempfail = [];
      this.mDataleavetypefail = [];

      (this.sheetsdataallfail = [
        {
          name: "sheetsdataallfail",
          data: [],
        },
      ]),
        (this.sheetsempfail = [
          {
            name: "sheetsempfail",
            data: [],
          },
        ]),
        (this.sheetsleave_typefail = [
          {
            name: "sheetsleave_typefail",
            data: [],
          },
        ]),
        (this.sheetscompanyfail = [
          {
            name: "sheetscompanyfail",
            data: [],
          },
        ]),
        (this.mDataArray = data);
      this.mDataArray.forEach((item, index) => {

        item.company_id = item.company_id;
        item.leave_period_from = this.importconversedate(item.leave_period_from);
        item.leave_period_to = this.importconversedate(item.leave_period_to);

      });

      this.btnconfirmimportclose = false;
      this.btnconfirmimport = true;
      this.lockcollection = false;
    },
  },

  beforeCreate() {
    this.$store.state.navMenu = true;
  },
};
</script>

<style scoped>
.v-btn:not(.v-btn--round).v-size--default.buttonred {
  background-color: #9e3b1b;
  color: white;
}
</style>
